import { Component } from '@angular/core';
import { CustomToasterServiceService } from './Services/custom-toaster-service.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Safroo';

  isChatbotVisible = false;

  successMsg: string = ''
  showSuccess: boolean = false
  errorMsg: string = ''
  processMsg: string = ''
  showError: boolean = false
  showProcessing: boolean = false;

  constructor(private toast: CustomToasterServiceService, public router: Router) { }

  ngOnInit() {
    this.toast.successMessage$.subscribe((msg) => {
      if (msg) {
        this.successMsg = msg
        this.showSuccess = true
        this.showProcessing = false 
      } else {
        this.showSuccess = false
      }
      
    }

  
  )

    this.toast.errorMessage$.subscribe((msg) => {
      if (msg) {
        this.errorMsg = msg
        this.showError = true
        this.showProcessing = false // Immediately hide processing
      } else {
        this.showError = false
      }
    })

    this.toast.processMessage$.subscribe((msg) => {
      if (msg) {
        this.processMsg = msg
        this.showProcessing = true
      } else {
        this.showProcessing = false
      }
    })

    window.addEventListener('message', (event) => {
      if (event.data?.action === 'closeChatbot') {
        this.isChatbotVisible = false;
      }
    });

    const urlParts = window.location.pathname.split('/');
    const guid = urlParts[urlParts.length - 1];
    const chatbotName = urlParts[urlParts.length - 2];

    window.parent.postMessage({ guid, chatbotName }, '*');

      window.addEventListener('message', this.receiveMessage.bind(this));
  }

  toastClose() {
    this.showSuccess = false
    this.showError = false
    this.showProcessing = false
  }


  toggleChatbot() {
    this.isChatbotVisible = !this.isChatbotVisible;
  }
  closeChat() {
    this.isChatbotVisible = !this.isChatbotVisible;
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveMessage.bind(this));
  }


  receiveMessage(event: MessageEvent): void {
    if (event.data?.type === 'close-chatbot') {
      this.isChatbotVisible = false;
    }
  }

}